import React from 'react';
// @ts-ignore
import styles from './LaboratoryResultsToDescribeTimeout.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import CaseCountdownBadge from '../../../Case/Components/CaseCountdownBadge/CaseCountdownBadge';
import moment from 'moment';
import { LaboratoryResultMise } from '../../../../graphql/graphql';

interface Props {
	laboratoryResultMise: LaboratoryResultMise;
}

const LaboratoryResultsToDescribeTimeout: React.FC<Props> = ({
	laboratoryResultMise,
}) => {
	return (
		<div className={styles.wrapper}>
			<Text
				tx='component.laboratoryResultsToDescribeListItem.timeLeft'
				colon
				inline
			/>
			<CaseCountdownBadge
				className={styles.countDownBadge}
				solveTo={moment(laboratoryResultMise.solveTo)}
				createdAt={moment()}
			/>
		</div>
	);
};

export default LaboratoryResultsToDescribeTimeout;
